import styled, { keyframes } from "styled-components";
//interfaces
import { IHideSliderButton, ICustomAnimated } from "./interface";

const slideInLeft = keyframes`
  from {
    width: 0px;
  }

  to {
    width: 200px;
  }
`;

export const HideSliderButton = styled.button<IHideSliderButton>`
  display: flex;
  position: absolute;
  left: 100%;
  top: 0;

  width: 24px;
  height: 40px;

  border-radius: 0 6px 6px 0;
  border: none;

  cursor: pointer;
  user-select: none;
`;

export const CustomAnimated = styled.div<ICustomAnimated>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;

  width: 200px;

  align-items: center;
  justify-content: center;

  animation: ${slideInLeft} .2s linear;
  transition: display .2s linear;
`